<!--推荐-->
<template>
  <div class="relation">
    <div class="title SourceHanSansCN">相关推荐</div>
    <div class="u-flex-col">
      <div class="item" v-for="(item, index) in recommend" :key="index" @click="refresh(item)" v-if="index<3">
        <el-image style="width: 300px; height: 190px" :src="item.image" fit="cover" v-if="item.image"/>
        <p class="name SourceHanSansCN">{{ item.title }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {articleInfoRecommend} from '@/api/interfaceApi'
export default {
  name: "recomeThings",
  data() {
    return {
      recommend: [], //相关推荐
    }
  },
  props: {
    type: {
      type: String,
      default() {
        return '1'
      }
    }
  },
  methods: {
    //重新载入页面
    refresh(item) {
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (item.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query: {
            id: item.id,
            type: item.type,
          },
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      } else if (item.type == 1 && item.method_type == 'policy') {
        let routeData = this.$router.resolve({
          name: "DynamicDetail",
          query: {
            id: item.id,
            type: 3,
          },
          path: '/article/DynamicDetail',
        });
        window.open(routeData.href, '_blank')
      } else {
        if (item.cid == 0) {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: item.id,
              type: item.type,
              method_type: item.method_type
            },
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        } else if (item.method_type == "dynamic") {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: item.id,
              type: 1,
              method_type: item.method_type
            },
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        } else if (item.method_type == "policy") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: item.id,
              type: item.type,
              method_type: item.method_type
            },
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (item.method_type == "notice") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: item.id,
              type: item.type,
              method_type: item.method_type
            },
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (item.method_type == "article") {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: item.id,
              type: 1,
              method_type: item.method_type
            },
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        } else {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: item.id,
              type: item.type,
              method_type: item.method_type
            },
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        }
      }
    },
    getRecommend() {
      articleInfoRecommend({page: 1, type: this.type}).then(res => {
        if (res.code == 200) {
          this.recommend = res.content;
        }
      })
    }
  },
  mounted() {
    this.getRecommend();
  }
}
</script>

<style scoped lang="scss">
.relation {
  flex: 1;
  padding-top: 30px;
  position: sticky;
  top: 0;

  .title {
    font-size: 20px;
    padding-bottom: 20px;
  }

  .item {
    margin-bottom: 30px;
    cursor: pointer;
    border-bottom: 1px solid #dddddd;

    .name {
      font-size: 16px;
      margin-top: 10px;
      color: #333333;
      margin-block-end: 30px;
    }
  }

  .item:last-child {
    margin-bottom: 30px;
    cursor: pointer;
    border-bottom: none;
  }
}
</style>